import type { AntennaEditionInput, AntennaId, AntennaSummary } from '@wwf/sdk';
import { RAFile } from '../types';

export type AntennaInput = AntennaEditionInput & {
    id?: AntennaId;
    coverInput?: RAFile;
};

export function antennaSummaryToInput(summary: AntennaSummary): AntennaInput {
    const {
        cover,
        createdAt,
        updatedAt,
        organizationId,
        nbMissions,
        nbMembers,
        nbMedias,
        ...edition
    } = summary;

    return {
        ...edition,
        coverId: cover?.id ?? null,
    };
}
